import { Button2 } from "@/ui2/atoms/Button";
import { Heading2 } from "@/ui2/atoms/Heading";
import { ModalControlled2 } from "@/ui2/molecules/Modal";

type OptOutConfirmationModalProps = {
  patientName: string;
  onOpenChange: (isOpen: boolean) => void;
  isModalOpen: boolean;
  onConfirmPress: () => void;
  onCancelPress: () => void;
};

export function OptOutConfirmationModal({
  patientName,
  onOpenChange,
  isModalOpen,
  onConfirmPress,
  onCancelPress,
}: OptOutConfirmationModalProps) {
  return (
    <ModalControlled2 isOpen={isModalOpen} onOpenChange={onOpenChange}>
      <div className="tw:flex tw:flex-col tw:gap-6">
        <Heading2 size={2}>Opt out from Advanced Care Program?</Heading2>

        <Divider />

        <p className="tw:text-text-secondary body-md">
          At the patient's request, this will remove {patientName}'s Advanced
          <br />
          Care Program consent.
        </p>

        <Divider />

        <div className="tw:flex tw:justify-end tw:gap-x-3">
          <Button2 variant="secondary" onPress={onCancelPress} size="md">
            Cancel
          </Button2>

          <Button2 variant="destructive-secondary" onPress={onConfirmPress} size="md">
            Opt Out
          </Button2>
        </div>
      </div>
    </ModalControlled2>
  );
}

const Divider = () => (
  <div className="tw:h-px tw:bg-stroke-quaternary tw:-translate-x-6 tw:-left-3 tw:w-[calc(100%+theme(spacing.12))]" />
);
